import { useEffect } from 'react';
import { UseFormReturn, useWatch } from 'react-hook-form';

import { useSelectedDeliveryMethodStore } from '@/entities/delivery-method';
import type { FormFields } from '@/entities/purchase-form';

type UseUpdateStoresProps = {
    formControl: UseFormReturn<FormFields>['control'];
};

export const useUpdateStores = ({ formControl }: UseUpdateStoresProps) => {
    const { setMethod: setDeliveryMethod } = useSelectedDeliveryMethodStore();

    const fulfilmentMethod = useWatch<FormFields, 'fulfilmentMethod'>({
        control: formControl,
        name: 'fulfilmentMethod',
    });

    useEffect(() => {
        setDeliveryMethod(fulfilmentMethod);
    }, [fulfilmentMethod]);
};
